import { CSSProperties } from "react";
import FontWeight from "../../../models/constants/FontWeight";

export default class ToggleViewStyle {

    background : CSSProperties = {
        display : 'flex',
        alignItems : 'center',
        justifyContent : 'center',
        marginTop: 10,
        marginRight: 10,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 8, 
        paddingRight: 8,
        cursor : 'pointer'
    }   

    text : CSSProperties = {
        fontFamily : 'Roboto',
        fontWeight : FontWeight.EXTRA_LIGHT,
        fontSize : 16    
    }
}